import { axiosRubyClient } from '@/util/axios/axiosClient';

export interface Skill {
  id: number;
  name: string;
  display_name_en?: string;
  display_name_es?: string;
  description_en?: string;
  description_es?: string;
  requirements?: string[];
  certificate?: {
    type: string;
    label: string;
  } | null;
  requires_certificate?: boolean;
}

export interface SkillRequestV2 {
  id: number;
  skill_id: number;
  worker_id: number;
  work_experience_completed: boolean;
  assessment_passed: boolean;
  uniform_photo_uploaded: boolean;
  certificate_photo_uploaded: boolean;
  work_experience_completed_at: string | null;
  assessment_passed_at: string | null;
  uniform_photo_uploaded_at: string | null;
  certificate_photo_uploaded_at: string | null;
  accepted_at: string | null;
  rejected_at: string | null;
  status: string;
  completion_percentage: number;
  created_at: string;
  updated_at: string;
  skill: Skill;
}

export interface WorkerCertificatePhoto {
  id: number;
  worker_id: number;
  skill_id: number;
  type: string | null; // e.g., "driver_license"
  image_key: string;
  image_url: string | null; // Full S3 URL to the image
  status: 'pending' | 'verified' | 'rejected';
  expires_at: string | null; // ISO 8601 format
  created_at: string; // ISO 8601 format
  updated_at: string; // ISO 8601 format
  worker?: {
    id: number;
    user: {
      id: number;
      email: string;
      phone_number: string | null;
      first_name: string;
      last_name: string;
    };
    city: string | null;
    state: string | null;
    zip: string | null;
    onboarding_status: string | null;
    background_status: string | null;
  };
  skill?: Skill;
  skill_request_v2?: SkillRequestV2 | null; // Single skill request object (not array)
}

export interface ListCertificatesResponse {
  success: boolean;
  photos: WorkerCertificatePhoto[];
}

export interface VerifyCertificateResponse {
  success: boolean;
  photo: WorkerCertificatePhoto;
}

export interface RejectCertificateResponse {
  success: boolean;
  photo: WorkerCertificatePhoto;
}

// Fetch pending certificates
export const fetchPendingCertificates =
  async (): Promise<ListCertificatesResponse> => {
    const response = await axiosRubyClient.get(
      '/api/admin/certificate_photos',
      {
        params: { status: 'pending' },
      },
    );
    return response.data;
  };

// Verify a certificate
export const verifyCertificate = async (
  id: number,
): Promise<VerifyCertificateResponse> => {
  // No request body required - can send empty JSON object or omit body
  const response = await axiosRubyClient.post(
    `/api/admin/certificate_photos/${id}/verify`,
    {},
  );
  return response.data;
};

// Reject a certificate
export const rejectCertificate = async (
  id: number,
  comment?: string,
): Promise<RejectCertificateResponse> => {
  const response = await axiosRubyClient.post(
    `/api/admin/certificate_photos/${id}/reject`,
    { comment },
  );
  return response.data;
};
